import { api } from '../../shared/api/client';
import { adaptNotification } from '../../shared/api/adapters';
import type { ApiNotification, PaginatedResponse } from '../../shared/types/api';

export async function fetchNotifications(params?: { unreadOnly?: boolean; limit?: number }) {
  const q = new URLSearchParams();
  if (params?.unreadOnly) q.set('unreadOnly', 'true');
  if (params?.limit) q.set('limit', String(params.limit));
  const qs = q.toString() ? `?${q.toString()}` : '';
  const res = await api.get<PaginatedResponse<ApiNotification> | ApiNotification[]>(
    `/api/v1/notifications${qs}`,
  );
  const list = Array.isArray(res) ? res : res.data;
  return list.map(adaptNotification);
}

export async function markNotificationRead(id: string) {
  return api.patch(`/api/v1/notifications/${id}/read`);
}

export async function markAllRead() {
  return api.patch('/api/v1/notifications/read-all');
}
